module.exports = __webpack_public_path__ + "img/EMT-BRCA_10X_Section2.6690ce32.png";